<template>
  <div class="d-flex align-items-center h-100 w-100" style="oveflow-x:scroll; overflow-y:visible;">
    <div
      v-for="(riparazione,index) in riparazioni"
      :key="riparazione.id"
      @click="setSelectedDevice(riparazione,index)"
      class="ml-2 dispositivo d-flex flex-column"
      :class="{'selezionato' : selectedDevice===index}"
    >
      <div
        class="d-flex flex-row w-100 justify-content-center align-items-center"
        style="height:80%;"
      >
        <imageLoader :imgInfo="riparazione" style="height:80%; width:100%;"></imageLoader>
      </div>
      <div
        :id="idDinamico('disp_',index)"
        @click.stop="keepVisible(index)"
        class="rimuovi d-flex align-items-center justify-content-center"
        :class="{ keepVisible : dropDownOpened === index}"
      >
        <i class="fas fa-ellipsis-v"></i>

        <div
          :id="idDinamico('mnu_',index)"
          v-if="dropDownOpened===index"
          class="ilmenu" :class="{'fade-in-top' : mnuReverse === false , 'fade-in-bottom' : mnuReverse === true}"
          :style="{ top: menuPosition.top + 'px', left: menuPosition.left + 'px' }"
        >
          <a  @click.stop="apriInfo(index),outSideClick()" class="dropdown-item" href="#">
            <i class="fas fa-info-circle"></i> &nbsp; &nbsp;Dettagli Dispositivo
          </a>
          <a @click.stop="removeDevice(index) ,outSideClick()" class="dropdown-item" href="#">
            <i class="fas fa-trash"></i> &nbsp; &nbsp;Rimuovi
          </a>
        </div>
      </div>

      <div class="flex-grow-1 w-100" style="font-size:1.4vh; height:2.5vh;">
        <div>{{ riparazione.dispositivo}}</div>
      </div>
    </div>
    <!--<div class="ml-3 dispositivo d-flex flex-column">
<div class="d-flex flex-row w-100 justify-content-center align-items-center" style="height:80%;">
<img style="height:80%; width:auto;" src="https://firebasestorage.googleapis.com/v0/b/jestionale-bfde2.appspot.com/o/Altro_mondo%2Fmodelli%2F-LaCerCK4ArZsDzAwiw3?alt=media">
</div>
<div class="flex-grow-1 w-100" style="font-size:1.4vh; height:2.5vh;">
<div>iPhone 6</div>
</div>
</div>
    -->

    <div @click.stop="newDevice()" class="align-self-center tasto_agg_disp">+</div>

    <div v-if="dropDownOpened!=null" @click="outSideClick()" class="outSideClickCapture"></div>
  </div>
</template>

<script>
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import Vue from "vue";
import { jStore } from "../store/jestionaleStore.js";
import { mapState, mapGetters } from "vuex";

export default {
  name: "DeviceList",
  directives: {},
  props: ["riparazioni", "selectedDevice"],
  data() {
    return {
      menuPosition: { top: "", left: "" },
      dropDownOpened: null,
      mnuReverse : false
    };
  },
  computed: {},
  methods: {
    apriInfo(index) {
    this.$store.commit("ordineStates/mostraInfo", index);     
    },
    idDinamico(prefix, id) {
      return prefix + id;
    },
    keepVisible(index) {
      this.mnuReverse = false
      var self = this;
      this.dropDownOpened = index;
      Vue.nextTick(function() {
        let tasto = document.getElementById("disp_" + index);
        let menu = document.getElementById("mnu_" + index);
        //var style = tasto.currentStyle || window.getComputedStyle(tasto);
        var posizione = self.getPosition(tasto);
        let x_limit = window.innerWidth;
        let larghezza = menu.offsetWidth;
        let altezza = menu.offsetHeight;
        let x_extension = parseInt(posizione.x) + parseInt(larghezza);
        self.menuPosition.top = parseInt(posizione.y + 25);
        self.menuPosition.left = parseInt(posizione.x);

        if (x_extension > x_limit) {
          //this.posizioneFormY =
          //parseInt(parametri[0].y) - this.altezzaForm - distanzia;
          self.mnuReverse = true
          
          self.menuPosition.top =  parseInt(posizione.y - altezza);
          self.menuPosition.left = parseInt(posizione.x - larghezza)
        }
      });
    },
    outSideClick() {
      this.dropDownOpened = null;
    },
    newDevice() {
      this.$emit("newDevice");
    },
    setSelectedDevice(obj, value) {
      var payload = {
        device: obj,
        index: value
      };
      this.$emit("setSelectedDevice", payload);
    },
    removeDevice(value) {
      this.$emit("removeDevice", value);
    },
    getPosition(el) {
      var xPos = 0;
      var yPos = 0;
      while (el) {
        if (el.tagName == "BODY") {
          // deal with browser quirks with body/window/document and page scroll
          var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
          var yScroll = el.scrollTop || document.documentElement.scrollTop;
          xPos += el.offsetLeft - xScroll + el.clientLeft;
          yPos += el.offsetTop - yScroll + el.clientTop;
        } else {
          // for all other non-BODY elements
          xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
          yPos += el.offsetTop - el.scrollTop + el.clientTop;
        }
        el = el.offsetParent;
      }
      return {
        x: xPos,
        y: yPos
      };
    }
  },
  mounted() {},
  watch: {}
};
</script>

<style>
.keepVisible {
  opacity: 1 !important;
  background-color: rgb(0, 154, 255) !important;
  color: white !important;
}

.outSideClickCapture {
  position: fixed;
  height: 100%;
  width: 100%;
  background: none;
  top: 0px;
  left: 0px;
  opacity: 0.5;
  z-index: 9998;
}

.ilmenu {
  background-color: white;
  z-index: 99999 !important;
  position: fixed;
  -webkit-box-shadow: 0px 0px 18px -8px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 18px -8px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 18px -8px rgba(0, 0, 0, 0.75);
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;
  padding: 0.5vw;
  text-align: left;
}

.dropdown > i {
  background-color: #949595;
  color: white;
  outline: none !important;
  border-radius: 50%;
  height: 2vh;
  width: 2vh;
  text-align: center;
  line-height: 2.3vh;
  font-size: 1em;
}

.dropdown-item {
  color: #636363;
  font-size: 1.9vh;
}

.dropdown button:hover {
  background-color: #6c757d;
}

.dropdown button:focus {
  outline: none !important;
}

.dispositivo {
  position: relative;
  height: 70%;
  border-bottom: solid 3px #d1d1d1;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  min-width: 13vh;
  -webkit-box-shadow: 2px 2px 8px -1px rgba(0, 0, 0, 0.07);
  -moz-box-shadow: 2px 2px 8px -1px rgba(0, 0, 0, 0.07);
  box-shadow: 2px 2px 8px -1px rgba(0, 0, 0, 0.07);
}

.dispositivo:hover > .rimuovi {
  opacity: 1;
}

.rimuovi {
  opacity: 0;
  position: absolute;
  right: 0px;
  top: -10px;
  height: 20px;
  width: 20px;
  background-color: #f7f7f7;
  font-size: 11px;

  cursor: pointer;

  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  color: grey;
  -webkit-box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.26);
  -moz-box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.26);
  box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.26);
}

.dispositivo img {
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
  opacity: 0.5;
}

.selezionato {
  font-weight: bold;
  border-bottom: solid 3px #11b9d6;
}

.selezionato img {
  -webkit-filter: grayscale(0%) !important; /* Safari 6.0 - 9.0 */
  filter: grayscale(0%) !important;
  opacity: 1 !important;
}

.tasto_agg_disp {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #f7f7f7;
  color: #a9a9a9;
  font-size: 20px;
  line-height: 30px;
  text-align: center;

  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
  margin-left: 2vw;
}

.tasto_agg_disp:hover {
  color: #939393;

  cursor: pointer;
  line-height: 30px;
  text-align: center;
}

.tasto_agg_disp:focus {
  outline: none;
  border: solid 1px #d6d6d6;
}

.fade-in {
  -webkit-animation: fade-in 0.5s cubic-bezier(0.39, 0.575, 0.565, 1);
  animation: fade-in 0.5s cubic-bezier(0.39, 0.575, 0.565, 1);
}

/* ----------------------------------------------
 * Generated by Animista on 2019-7-26 0:32:48
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation fade-in
 * ----------------------------------------
 */
@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.fade-in-top {
  -webkit-animation: fade-in-top 0.2s both;
  animation: fade-in-top 0.2s both;
}

@-webkit-keyframes fade-in-top {
  0% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fade-in-top {
  0% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

.fade-in-bottom {
	-webkit-animation: fade-in-bottom 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
	        animation: fade-in-bottom 0.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}


@-webkit-keyframes fade-in-bottom {
  0% {
    -webkit-transform: translateY(20px);
            transform: translateY(20px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fade-in-bottom {
  0% {
    -webkit-transform: translateY(20px);
            transform: translateY(20px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
}

</style>
